import {axios} from "~/plugins/request"

export const state = () => {
  return {}
}
export const mutations = {}
export const actions = {
  findProfessionList({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post('/profession/findProfessionList', params).then(res => {
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },
  findCategoriesNameList({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post('/profession/findCategoriesNameList', params).then(res => {
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },
  findSubjectNameByCategoryList({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post('/profession/findSubjectNameByCategoryList', params).then(res => {
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },

  findInfoById({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post('/profession/findInfoById', params).then(res => {
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },

  saveStudentSpeciality({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post('/university/saveStudentSpeciality', params).then(res => {
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },


}
